/* eslint-disable */
import type { Color } from "../../cash/ui/Color.pb";
import type { Image } from "../../cash/ui/Image.pb";

export enum TaskType {
  PAYSTUBS = "PAYSTUBS",
  INCOME = "INCOME",
  EMPLOYMENT = "EMPLOYMENT",
  SHIFTS = "SHIFTS",
  DIRECT_DEPOSIT_SWITCH = "DIRECT_DEPOSIT_SWITCH",
  DIRECT_DEPOSIT_PAYMENT = "DIRECT_DEPOSIT_PAYMENT",
  DIRECT_DEPOSIT_ALLOCATIONS = "DIRECT_DEPOSIT_ALLOCATIONS",
  IDENTITY = "IDENTITY",
  TAX_FORMS = "TAX_FORMS",
  PAYOUT_CARDS = "PAYOUT_CARDS",
  CARD_SWITCH = "CARD_SWITCH",
  COMPANY_CENSUS = "COMPANY_CENSUS",
  COMPANY_EMPLOYMENTS = "COMPANY_EMPLOYMENTS",
}

export enum PayrollVendor {
  UNKNOWN = "UNKNOWN",
  PINWHEEL = "PINWHEEL",
}

export enum PayrollProviderType {
  EMPLOYER = "EMPLOYER",
  PLATFORM = "PLATFORM",
}

/**
 * In addition to their payroll account, some users may have a separate
 * T&A account for recording shifts and other data.
 */
export enum PlatformType {
  PAYROLL = "PAYROLL",
  TIME_AND_ATTENDANCE = "TIME_AND_ATTENDANCE",
}

export interface PayrollProvider {
  employer?: Employer | undefined;
  platform?: Platform | undefined;
  ui_specification?: PayrollProviderUiSpecification;
  supported_tasks?: TaskType[];
  direct_deposit_info?: DirectDepositInfo;
}

export interface PayrollProviderUiSpecification {
  avatar?: PayrollProviderUiAvatar;
  title?: string;
}

export interface PayrollProviderUiAvatar {
  avatar_url?: Image;
  avatar_accent_color?: Color;
}

export interface SourceIdentifier {
  source_vendor?: PayrollVendor;
  source_id?: string;
  payroll_provider_type?: PayrollProviderType;
}

export interface Employer {
  token?: string;
  canonical_name?: string;
  source_id?: SourceIdentifier;
}

export interface Platform {
  token?: string;
  canonical_name?: string;
  source_id?: SourceIdentifier;
  type?: PlatformType;
}

export interface DirectDepositInfo {
  /** Whether or not the platform accepts an amount for direct_deposit_switch. */
  amount_supported?: boolean;
  /** Whether or not the platform accepts decimal values for direct_deposit_switch. */
  fractional_amount_supported?: boolean;
  /** Maximum amount, if any, platform accepts for direct_deposit_switch. */
  max_amount_cents?: number;
  /** Minimum amount, if any, platform accepts for direct_deposit_switch. */
  min_amount_cents?: number;
}
